import React from 'react'
import { SvgIcon } from '@mui/material'

export const EditTickIcon = props => {
  return (
    <SvgIcon
      viewBox="0 0 34 34"
      sx={{ color: 'secondary.main', width: '34px', height: '34px' }}
      {...props}
    >
      <path
        d="M26.54 9.93a1.42 1.42 0 0 0-1-.43 1.39 1.39 0 0 0-1.02.43l-10.6 10.95-4.46-4.6a1.45 1.45 0 0 0-1.03-.43 1.42 1.42 0 0 0-1.02.46A1.5 1.5 0 0 0 7 17.38a1.54 1.54 0 0 0 .44 1.05l5.47 5.64a1.42 1.42 0 0 0 1 .43 1.39 1.39 0 0 0 1.02-.43l11.61-11.98a1.47 1.47 0 0 0 .46-1.08 1.5 1.5 0 0 0-.46-1.08Z"
        fill="#55A6FF"
      />
    </SvgIcon>
  )
}
